export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';

export const RESET_INGREDIENT = 'RESET_INGREDIENT';

export const ORDER_LOAD_SUCCESS = 'ORDER_LOAD_SUCCESS';
export const ORDER_LOAD_FAILED = 'ORDER_LOAD_FAILED';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_lOADING = 'AUTH_LOADING';
export const AUTH_lOGOUT = 'AUTH_LOGOUT';
